import { render } from "./Process.vue?vue&type=template&id=322207c9&ts=true"
import script from "./Process.vue?vue&type=script&lang=ts"
export * from "./Process.vue?vue&type=script&lang=ts"

import "./Process.vue?vue&type=style&index=0&id=322207c9&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__